import React, { useState } from 'react';

import './Infographic.css';

// This component is for a graph/chart thing
// that also includes a header, desc, and options to change the display
const Infographic = (props) => {
  const [dispSelection, setDispSelection] = useState(
    props.defaultSelection,
  ); // Current options are 'bar', 'pie', and 'table'

  const classes = () => {
    switch (props.width) {
      case 'half':
        return 'ontario-columns ontario-small-12 ontario-medium-6 ontario-margin-bottom-32-!';
      case 'default':
        return '';
      case 'full':
        return 'ontario-columns ontario-small-12 ontario-medium-12 ontario-margin-bottom-32-! infographic';
      default:
        break;
    }
  };
  return (
    <div id={props.id} className={classes()}>
      {/* Title and desc */}
      {/* Defaults to using the descTitle prop if there is one */}
      {props.titleDesc && props.titleDesc.title && (
        <h3
          className="margins"
          dangerouslySetInnerHTML={{
            __html: props.titleDesc
              ? props.titleDesc.title[props.lang]
              : props.title[props.lang],
          }}
        />
      )}
      {props.titleDesc && props.titleDesc.desc && (
        <p
          dangerouslySetInnerHTML={{
            __html: props.titleDesc
              ? props.titleDesc.desc[props.lang]
              : props.desc[props.lang],
          }}
        />
      )}
      {/* The actual info part */}
      {props[dispSelection]}
    </div>
  );
};

Infographic.defaultProps = {
  opts: ['bar', 'table'],
  width: 'half',
  title: 'title',
  desc: 'description',
  defaultSelection: 'bar',
};

export default Infographic;
